<div class="avi-dropdown-single-selected-value sel-avi-dropdown-single-selected-value">
    <ng-content></ng-content>
</div>
